export default "__VITE_ASSET__CHHYsaYB__"